import React,{useState} from "react";
import GraphWrapper from "../../Wrapper/GraphWrapper";
import { LoanComposition } from "../d3Charts/charts/LoanComposition";
import { BankComparison } from "../d3Charts/charts/BankComparison";
import { StackedBarChart } from "../d3Charts/charts/StackedBarChart";
import {BarChart} from "../d3Charts/charts/BarChart";
import { PercentileChart } from "../d3Charts/charts/PercentileChart";
import ChartDropdown from "./ChartDropdown";
import "./GraphRenderer.css";
import "./GraphRenderer.css";
export const GraphRenderer: React.FC<any> = ({ data, queryData, message }) => {
    const [selectedCharts, setSelectedCharts] = useState<{ [key: string]: string }>({});
   
    const handleChartSelection = (assignedId: string, chartType: string) => {
      setSelectedCharts((prev) => ({
        ...prev,
        [assignedId]: chartType,
      }));
    };
   
    const renderContent = () => {
      switch (queryData) {
        case "loan":
          return (
            <>
              <div className="loan-bar-section">
                <GraphWrapper>
                  {selectedCharts[message.assignedId] === "bar" ? (
                    <BarChart data={data} />
                  ) : (
                    <LoanComposition data={data} />
                  )}
                </GraphWrapper>
                <ChartDropdown
                  assignedId={message.assignedId}
                  selectedChart={selectedCharts[message.assignedId] || "loan"}
                  onSelectChart={(chartType) => handleChartSelection(message.assignedId, chartType)}
                />
              </div>
              <div style={{ marginLeft: "10px" }}>
                <GraphWrapper>
                  <StackedBarChart data={data} />
                </GraphWrapper>
              </div>
            </>
          );
        case "compare":
          return (
            <GraphWrapper>
              <BankComparison data={data} />
            </GraphWrapper>
          );
        default:
          return (
            <GraphWrapper>
              <PercentileChart data={data}/>
            </GraphWrapper>
          );
      }
    };
    return <>{renderContent()}</>;
};
